import { AgreementsDataType } from "@/types/AgreementsDataType";
import Link from "next/link";

export default function getLeadFormAgreementsData(): Array<AgreementsDataType> {
  return [
    {
      id: "ZGODA_1",
      content: (
        <>
          Chcę otrzymać ofertę dotyczącą projektów inwestycyjnych na podany
          adres e-mail lub telefonicznie. Znam i akceptuję treść{" "}
          <Link
            href="/polityka-prywatnosci"
            className="font-bold"
            target={"_blank"}
          >
            Polityki Prywatności
          </Link>{" "}
          i{" "}
          <Link href="/regulamin" className="font-bold" target={"_blank"}>
            Regulaminu ŚUDE
          </Link>
          . Wiem, że dane osobowe podane w formularzu będą przetwarzane w celu
          przedstawienia mi oferty dotyczącej projektów inwestycyjnych na
          podstawie mojej zgody (art. 6 ust. 1 lit. a RODO), którą mogę wycofać
          w dowolnym momencie, co nie wpłynie na zgodność z prawem przetwarzania
          dokonanego przed jej wycofaniem. Administratorem moich danych
          osobowych będzie Oak Property sp. z o.o. z siedzibą w Warszawie
          (00-411) przy ul. Wioślarskiej 8. Więcej informacji o administratorze,
          odbiorcach danych, celach przetwarzania i moich prawach znajdę w{" "}
          <Link
            href="/polityka-prywatnosci"
            className="font-bold"
            target={"_blank"}
          >
            Polityce Prywatności
          </Link>
          .
        </>
      ),
      description: null,
      priority: 1,
      isRequired: true,
      isStatement: false,
    },
    {
      id: "ZGODA_2",
      content: (
        <>
          Chcę otrzymywać cyklicznie oferty dotyczące projektów inwestycyjnych
          na podany adres e-mail lub telefonicznie. Znam i akceptuję treść{" "}
          <Link
            href="/polityka-prywatnosci"
            className="font-bold"
            target={"_blank"}
          >
            Polityki Prywatności
          </Link>{" "}
          i{" "}
          <Link href="/regulamin" className="font-bold" target={"_blank"}>
            Regulaminu ŚUDE
          </Link>
          . Wiem, że dane osobowe podane w formularzu będą przetwarzane w celu
          przedstawiania mi ofert dotyczących projektów inwestycyjnych na
          podstawie mojej zgody (art. 6 ust. 1 lit. a RODO), którą mogę wycofać
          w dowolnym momencie, co nie wpłynie na zgodność z prawem przetwarzania
          dokonanego przed jej wycofaniem. Administratorem moich danych
          osobowych będzie Oak Property sp. z o.o. z siedzibą w Warszawie
          (00-411) przy ul. Wioślarskiej 8. Więcej informacji o administratorze,
          odbiorcach danych, celach przetwarzania i moich prawach znajdę w{" "}
          <Link
            href="/polityka-prywatnosci"
            className="font-bold"
            target={"_blank"}
          >
            Polityce Prywatności
          </Link>
          .
        </>
      ),
      description: null,
      priority: 2,
      isRequired: true,
      isStatement: false,
    },
  ];
}
